export const supportingDocumentRequired = [
  'BC',
  'PPE',
  'CC',
  'CN',
  'UC',
  'LB',
  'CB',
]

export const citizenSupportingDocumentNotRequired = [
  'PP',
  'EID',
  'TC',
  'FS',
  'DLE',
  'ETC',
]

export const nonCitizenSupportingDocumentNotRequired = ['ARU', 'RP', 'FP']

/**
 * Photo IDs the pod accepts but web pre-enrollment does not. The lookup service serves one
 * list to both, so the dropdown has to drop these itself.
 *
 * ARX is an expired Permanent Resident Card backed by a Form I-797 Notice of Action. Only
 * an Ambassador can attest, in person, that the applicant holds the I-797, so the web flow
 * is out of scope for it.
 */
export const photoIdsNotSupportedOnWeb = ['ARX']

export const excludeUnsupportedPhotoIds = <T extends { value: string }>(
  photoIds: T[]
): T[] =>
  photoIds.filter(({ value }) => !photoIdsNotSupportedOnWeb.includes(value))

/**
 * Labels the lookup service renamed for the pod, mapped back to the wording web has always
 * shown. ARU only needs the word "Unexpired" where the expired card is also on offer, which
 * is the pod and not here. Keyed by lookup category, then by value.
 */
const labelOverrides: Record<string, Record<string, string>> = {
  'non-us-citizen-photo-ids': {
    ARU: 'Permanent Resident Card',
  },
}

export const applyLabelOverrides = <T extends { value: string; label: string }>(
  category: string,
  options: T[]
): T[] => {
  const overrides = labelOverrides[category]
  if (!overrides) return options

  return options.map((option) =>
    overrides[option.value]
      ? { ...option, label: overrides[option.value] }
      : option
  )
}
